export enum Policies {
    PrivacyPolicy = 1,
    TermsAndConditions = 2,
    CookiePolicy = 3,
}
